import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    <a
      href="https://github.com/linkwithjs/portfolio"
      className="link footer__link"
    >
      &copy; Rajenda Lungeli
    </a>
  </footer>
);

export default Footer;
